export default __webpack_public_path__ + "static/media/engine.341520f6.svg";